<template>
  <div class="yh-page">
    <el-card class="pt-3" v-loading="loading" :element-loading-text="loadingText">
      <el-form :rules="rules" ref="dataForm" :model="new_billing_file" label-position="right" label-width="160px">

        <el-row>
          <el-col :span="11" >
            <!-- 文件标题 -->
            <el-form-item label="文件名称" prop="title">
              <el-input v-model="new_billing_file.title" placeholder="请输入文件标题"></el-input>
            </el-form-item>       

            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" row="5" v-model="new_billing_file.remark" placeholder="请输入备注"></el-input>
            </el-form-item>       
            <!-- 开始时间 -->
            <!-- <el-form-item  label="开始时间" prop="start_time">
              <el-date-picker v-model="new_billing_file.start_time"
                              type="date" value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="开始时间" class="w-100"></el-date-picker>
            </el-form-item> -->

            <!-- 结束时间 -->
            <!-- <el-form-item  label="结束时间" prop="end_time">
              <el-date-picker v-model="new_billing_file.end_time"
                              type="date" value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="结束时间" class="w-100"></el-date-picker>
            </el-form-item> -->
          </el-col>

          <el-col :span="11" >                     
          </el-col>          
        </el-row>
        
        <el-row>
          <el-col :span="24" class="border-top mt-2 pt-3">
            <el-form-item>
              <el-button size="small" @click="cancelData">取消</el-button>
              <el-button v-if="pageStatus == 'action.edit' && showEdit" size="small"
                         type="primary" @click="updateData">保存
              </el-button>
              <template v-if="pageStatus == 'action.add' && showAdd">
                <el-button size="small" type="primary" @click="createData(1)">保存</el-button>
                <el-button size="small" type="primary" @click="createData(2)">保存并新增</el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
  import {validateMobileNumber} from '@/utils/validate'
  import {createBillingFile, fetchBillingFile, updateBillingFile} from '@/api/billing'    

  export default {
    name: "billing-file",
    data() {
      return {
        rules: {
          // name: [{required: true, message: '请输入客户名称', trigger: 'blur'}],
          // type: [{required: true, message: '请选择客户类型', trigger: 'blur'}],
          // actual_controller: [{required: true, message: '请输入实际控制人信息', trigger: 'blur'}],
          // contact: [{required: true, message: '请输入联系人信息', trigger: 'blur'}],
          // mobile: [{required: true, message: '请输入有效的手机号码', trigger: 'blur', validator: validateMobileNumber}]
        },
        showAdd: false,
        showEdit: false,
        loading: false,
        loadingText: '正在加载数据，请销等...',
        new_billing_file: {
          title: "",
          company_code: "",
          company: "",
          total_details: 0,
          creator: "",
          start_time: new Date(),
          end_time:  new Date(),
          status: 0
        },
        pageStatus: '',
        id: 0
      }
    },
    methods: {
      reset_new_billing_file() {
        this.new_billing_file = {}
      },
      showCreateView() {
        this.pageStatus = 'action.add'
      },
      showUpdateView(id) {
        console.log("id: " + id)
        this.pageStatus = 'action.edit'
        fetchBillingFile(id)
          .then(res => {
            this.new_billing_file = Object.assign({}, res)
            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate()
            })
          })
          .catch(error => {
            this.$message.error(error)
          })
      },
      cancelData() {
        this.$refs.dataForm.resetFields()
        this.reset_new_billing_file()
        this.$router.go(-1)
        // this.$router.push({name: 'billingFileList'})
      },
      createData(type) {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.loading = true
            this.loadingText = '正在保存账单文件信息数据，请稍等...'
            this.new_billing_file.company_code = this.company
            createBillingFile(this.new_billing_file)
              .then(res => {
                this.BillingFileId = res.id
                this.loadingText = "保存账单文件信息成功"
              })
              .then(() => {
                this.loading = false
                this.$message.success('保存账单文件信息成功')
                this.$nextTick(() => {
                  this.$refs.dataForm.clearValidate()
                  this.$refs.dataForm.resetFields()
                  this.reset_new_billing_file()
                  if (type == 1) {
                    // this.$router.push({name: 'billingFileList'})
                    this.$router.go(-1)
                  }
                })
              })
              .catch(error => {
                this.$message.error(error)
              })
          }
        })
      },
      updateData() {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            const new_billing_file = Object.assign({}, this.new_billing_file)
            updateBillingFile(new_billing_file, new_billing_file.id)
              .then(() => {
                this.$message.success('更新账单文件信息成功')
                this.$nextTick(() => {
                  // this.$refs.dataForm.clearValidate()
                  // this.$refs.dataForm.resetFields()
                  // this.reset_new_billing_file()
                  setTimeout(() => {
                    // this.$router.push({name: 'billingFileList'})
                    this.$router.go(-1)
                  }, 200)
                })
              })
              .catch(error => {
                this.$message.error(error)
              })
          }
        })
      },
    },
    created() {
      // 入参检查
      if (this.$route.query.company === undefined) {
        this.$$router.push('/404')
      }
      this.company = this.$route.query.company

      // 处理新增
      if (this.$route.name == 'createBillingFile') {
        if (!this.$perm(["billing.create_billing_file"])) {
          this.$router.push('/401')
        }
        this.showAdd =  true
        this.showCreateView()
        return 
      } 

      console.log('company ok')
      // 处理更新
      if (!this.$perm(["billing.update_billing_file"])) {
        this.$router.push('/401')
      }
      if (this.$route.query.fileId === undefined){
        console.log("id: " + this.$route.query.fileId)
        this.$router.push('/404')
      }
      this.showEdit = true 
      this.id = this.$route.query.fileId
      this.showUpdateView(this.id)

    }
  }
</script>
